import { useLazyQuery as i } from "@apollo/client";
import { accountSchema as m } from "../../deserialize/yup/account.js";
import { deserializeData as f } from "../../graphql/deserialize/index.js";
import u from "../../graphql/query/getAccountDetail.js";
import { getAccessToken as p, getRefreshToken as l } from "../../util/authenication/index.js";
import * as t from "ramda";
import { useState as h, useCallback as d } from "react";
const z = () => {
  const [e, { loading: a }] = i(u), [s, c] = h(null);
  return {
    fetch: d(async () => {
      const r = await e(), n = t.pipe(
        t.assocPath(["data", "accessToken"], p()),
        t.assocPath(["data", "refreshToken"], l())
      ), o = f(
        n(r),
        m
      );
      return c(o), o;
    }, [e]),
    data: s,
    loading: a
  };
};
export {
  z as default
};
//# sourceMappingURL=useGetAccountDetail.js.map
